import React from 'react';

import { MobileActionButton } from './ActionButtons';

export const MobileCard = ({ item, columns, actions }) => {
  const primaryColumn = columns.find(col => col.primary) || columns[0];
  const secondaryColumns = columns.filter(col => col.key !== primaryColumn?.key);

  return (
    <>
      {/* Primary Info */}
      <div className="flex items-start justify-between mb-4">
        <div>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
            {primaryColumn?.render ?
              primaryColumn.render(item[primaryColumn.key], item) :
              (typeof item[primaryColumn?.key] === 'object' && item[primaryColumn?.key] !== null
                ? JSON.stringify(item[primaryColumn?.key])
                : item[primaryColumn?.key]
              )
            }
          </h3>
        </div>
      </div>
      
      {/* Secondary Info */}
      <div className="space-y-2 mb-4">
        {secondaryColumns.map((column) => (
          <div key={column.key} className="flex items-center justify-between">
            <span className="text-sm text-gray-600 dark:text-gray-400">
              {column.header}:
            </span>
            <div className="text-sm font-medium text-gray-900 dark:text-gray-100">
              {column.render ?
                column.render(item[column.key], item) :
                (typeof item[column.key] === 'object' && item[column.key] !== null
                  ? JSON.stringify(item[column.key])
                  : item[column.key]
                )
              }
            </div>
          </div>
        ))}
      </div>

      {/* Actions */}
      {actions.length > 0 && (
        <div className="flex space-x-3 pt-4 border-t border-gray-200 dark:border-gray-700">
          {actions.map((action, actionIndex) => (
            <MobileActionButton
              key={actionIndex}
              action={action}
              item={item}
            />
          ))}
        </div>
      )}
    </>
  );
};